<template>
    <g clip-path="url(#clip1)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.460815 1.76294L1.452 0.637085L5.49989 4.20077L9.54777 0.637085L10.539 1.76294L5.49989 6.19925L0.460815 1.76294Z" fill="#00AF41"/>
    </g>
    <defs>
        <clipPath id="clip1">
            <rect width="11" height="6" fill="white" transform="translate(0 0.5)"/>
        </clipPath>
    </defs>
</template>

<script>
    export default {
        name: 'icon-arrow-down'
    }
</script>